import "./NavBar.css";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { images } from "../../../../Assets/assetsHelper";
import MenuIcon from "@mui/icons-material/Menu";
import { BaseURL, logoutURL } from "../../../../Hooks/URL";
import useLogout from "../../../../Hooks/useLogout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { userContext } from "../../../../Contexts/userContext";
import config from "../../../../config";

function NavBar({ setShowMenu }) {
  const navigate = useNavigate();
  const { contextData, setContextData } = useContext(userContext);

  const [goSave, setGoSave] = useState(false);
  const { saveState } = useLogout({
    url: logoutURL,
    goSave,
    setGoSave,
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="nav">
      <Link className="NavLogo" to="/">
        <img alt="Logo" className="NavLogo" src={config.APP_LOGO} />
      </Link>
      <div className="rightNav">
        <div className="sidebarIcon" onClick={() => setShowMenu(true)}>
          <span className={"menuIcon"}>
            <MenuIcon
              sx={{
                fontSize: "27px",
                cursor: "pointer",
                marginTop: "5px",
                color: config.PRIMARY_COLOR,
              }}
            />
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <AccountCircleIcon
            style={{
              fontSize: "50px",
              color: config.PRIMARY_COLOR,
              marginRight: "10px",
              cursor: "pointer",
            }}
            className="desktop"
            onClick={() => {
              navigate("/");
            }}
          />
          <span
            className="desktop"
            style={{
              marginRight: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              navigate("/");
            }}
          >
            {contextData?.user?.name ?? "Administrator"}
          </span>
          <LogoutIcon
            style={{
              fontSize: "40px",
              color: config.PRIMARY_COLOR,
              marginLeft: "10px",
              cursor: "pointer",
            }}
            className="navIcon"
            onClick={() => setGoSave(true)}
          />
        </div>
      </div>
    </div>
  );
}

export default NavBar;
